import {
    FieldInCard,
} from 'app/types/form.types'

import {
    GeneralStatusChangeNote,
    Note,
} from 'app/Apps/ContainerManagement/Containers/components/Overview/ContainerNotes/ContainerNotes.types'

type Params = {
    showOrder?: boolean,
    removeAttachmentsField?: boolean,
}

export const getChangeConfig = (
    {
        showOrder,
        removeAttachmentsField,
    }: Params = {},
): FieldInCard<keyof Note> => {
    const config: FieldInCard<keyof Note> = {
        title: 'Change',
        className: 'change',
        fields:
            [
                {
                    name: 'noteSubject',
                    componentName: 'InputSingleline',
                    labelKey: 'Note.noteSubject',
                },
                {
                    name: 'noteText',
                    componentName: 'LongText',
                    labelKey: 'Note.noteText',
                },

            ],
    }

    if (!removeAttachmentsField) {
        config.fields.push({
            name: 'attachments',
            componentName: 'AttachmentsObjectSelector',
            labelKey: 'Note.attachments',
            disabled: true,
        })
    }
    if (showOrder) {
        config.fields.push({
            name: 'orderId',
            labelKey: 'ContainerCurrentOrder.orderNumber',
            componentName: 'OrderLink',
        })
    }
    return config
}

export const AuditTrailConfig: FieldInCard<keyof Note> = {
    title: 'Audit Trail',
    className: 'audit',
    fields: [
        {
            name: 'createdBy',
            componentName: 'InputSingleline',
            labelKey: 'Note.createdBy',
        },
        {
            name: 'createdOn',
            componentName: 'DateTimeSelect',
            labelKey: 'Note.createdOn',
            disabled: true,
        },
        {
            name: 'validDateTimestamp',
            componentName: 'DateTimeZonedSelect',
            labelKey: 'Note.validDateTimestamp',
        },
    ],
}

export const StatusChangeConfig: FieldInCard<keyof GeneralStatusChangeNote> = {
    title: 'Status Change',
    className: 'Status',
    fields: [{
        name: 'statusChange',
        componentName: 'StatusSelector',
        labelKey: 'Note.statusChange',
    }],
}
